interface InfoDescriptor
{
	value: string;
	id?: string;
	classes?: string[];
}

class InfoField
{

	protected element: HTMLElement;

	constructor( descriptor: InfoDescriptor )
	{
		this.element = document.createElement( 'span' );

		if ( descriptor.id )
		{
			$( this.element ).attr( 'id', descriptor.id );
		}
		$( this.element ).html( descriptor.value );

		if ( descriptor.classes )
		{
			for ( const i in descriptor.classes )
			{
				$( this.element ).addClass( 'label-' + descriptor.classes[ i ] );
			}
		}

	}

	public getElement() : HTMLElement
	{
		return this.element;
	}

}

class Label
	extends InfoField
{
		constructor( descriptor: InfoDescriptor )
		{
			super( descriptor );
			$( this.element ).addClass( 'label' );
		}

}

class Badges
	extends InfoField
{
		constructor( descriptor: InfoDescriptor )
		{
			super( descriptor );
			$( this.element ).addClass( 'badge' );
		}

}

type IconBase = 'glyphicon' | 'fa';

class Icon
{

		private element: HTMLElement;

		constructor( icon: string, base: IconBase = 'glyphicon' )
		{
			this.element = document.createElement( 'span' );

			$( this.element ).addClass( base + ' ' + base + '-' + icon );
		}

		public getElement() : HTMLElement
		{
			return this.element;
		}

}
